/* ══════════════════════════════════════════════════════════════════
   账户页运行时。三件小事，每一件没有它页面也是完整的：

     1. 地址删除要一次确认 —— 删地址没有撤销
     2. 省 / 州联动交给 Shopify 自己的脚本（它认 data-address-country 那套结构）
     3. 保修登记表单：配了 endpoint 就 POST JSON，成功后就地换一句话

   **这里没有任何凭据**：endpoint 是后台填的 URL，token 留在那一端。
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ── 删地址：确认一次 ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-address-delete]');
    if (!btn) return;
    e.preventDefault();
    if (!window.confirm(btn.dataset.confirm || 'Delete this address?')) return;

    var form = document.createElement('form');
    form.method = 'post';
    form.action = btn.dataset.addressDelete;
    form.innerHTML = '<input type="hidden" name="_method" value="delete">';
    document.body.appendChild(form);
    form.submit();
  });

  /* ── 省 / 州联动 ── */
  function provinces() {
    if (!window.Shopify || !Shopify.CountryProvinceSelector) return;
    document.querySelectorAll('[data-address-country]').forEach(function (sel) {
      if (sel.dataset.bound === '1') return;
      sel.dataset.bound = '1';
      new Shopify.CountryProvinceSelector(sel.id, sel.dataset.province, {
        hideElement: sel.dataset.provinceContainer
      });
    });
  }

  /* ── 保修登记 ── */
  function warrantyForm() {
    var form = document.querySelector('[data-warranty-form]');
    if (!form || form.dataset.bound === '1') return;
    form.dataset.bound = '1';

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      if (btn) btn.disabled = true;

      /* 字段名是 contact[...]（Shopify 联系表单只认这个前缀），发 JSON 时
         剥回裸键 —— 后台两条路收到的形状必须一样，否则 n8n 要写两套解析。 */
      var data = {};
      new FormData(form).forEach(function (v, k) {
        var m = k.match(/^contact\[(.+)\]$/);
        data[m ? m[1] : k] = v;
      });

      /* Turnstile 自己往表单里插 cf-turnstile-response，上面那圈 FormData
         已经收到了。托管模式下人通常不用点，但脚本没加载完就提交时它是空的
         —— 那就把按钮放开、提示一句，而不是发一个必然被后台拒掉的请求。 */
      if (form.querySelector('[data-eb-turnstile]') && !data['cf-turnstile-response']) {
        if (btn) btn.disabled = false;
        var wait = document.createElement('p');
        wait.className = 'eb-caption';
        wait.setAttribute('role', 'alert');
        wait.textContent = form.dataset.verify || 'Please complete the security check, then send again.';
        var old = form.querySelector('[data-warr-msg]');
        if (old) old.remove();
        wait.setAttribute('data-warr-msg', '');
        form.appendChild(wait);
        return;
      }

      fetch(form.dataset.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      })
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          /* 成功就地换成一句话 —— 不跳页，因为跳走的人不知道自己成功了没有 */
          var ok = document.createElement('p');
          ok.className = 'eb-auth__ok';
          ok.textContent = form.dataset.done || 'Submitted';
          form.replaceWith(ok);
        })
        .catch(function () {
          if (btn) btn.disabled = false;
          var err = form.querySelector('[data-warranty-error]');
          if (!err) {
            err = document.createElement('div');
            err.className = 'eb-auth__err';
            err.setAttribute('data-warranty-error', '');
            err.textContent = form.dataset.error || 'That did not go through. Please try again, or email us.';
            form.prepend(err);
          }
        });
    });
  }

  function mount() { provinces(); warrantyForm(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();
  document.addEventListener('shopify:section:load', mount);
})();
